import React, { Component, PropTypes } from 'react';
import ReactDOM from 'react-dom';
import Button from 'components/ButtonControl';

import './Modal.scss';

class Modal extends Component {

    static propTypes = {
        content: PropTypes.any.isRequired,
        saveText: PropTypes.string,
        closeText: PropTypes.string,
        isSaveButton: PropTypes.bool,
        isCloseButton: PropTypes.bool,
        onClose: PropTypes.func,
        onSave: PropTypes.func,
        buttonSaveId: PropTypes.string,
    }

    static defaultProps = {
        saveText: 'Сохранить',
        closeText: 'Отменить',
        isSaveButton: true,
        isCloseButton: true,
        buttonSaveId: ''
    };

    componentDidMount() {
        window.addEventListener('popstate', this._onCloseClick);
    }

    componentWillUnmount() {
        window.removeEventListener('popstate', this._onCloseClick);
    }

    _onMount = (component) => {
        this._modal = $(ReactDOM.findDOMNode(component));

        this._modal.on('shown.bs.modal', () => {
            if (this.props.onMount) {
                this.props.onMount();
            }
        });
        this._modal.modal('show');
        this._modal.on('hide.bs.modal', () => {
            if (this.props.onClose) {
                this.props.onClose();
            }
        });
    };

    _onSaveClick = () => {
        if (this.props.onSave) {
            this.props.onSave(this._modal);
        } else {
            this._modal.modal('hide');
        }
    };

    _onCloseClick = (target) => {
        this._modal.modal('hide');
        if (this.props.onClose) {
            this.props.onClose.call(null, target);
        }
    };

    render() {
        return (
            <div className="Modal">
                <div className="modal"
                    ref={this._onMount}>
                    <div className="Modal-modal modal-dialog">
                        <div className="Modal-content modal-content">
                            <div className="Modal-header modal-header">
                                <div>
                                    <button className="close"
                                        type="button"
                                        //data-dismiss="modal"
                                        onClick={this._onCloseClick.bind(this, 'close')}>
                                            <span>&times;</span>
                                    </button>
                                    <h4 className="Modal-title">{this.props.title}</h4>
                                </div>
                            </div>
                            <div className="Modal-body modal-body">
                                {this.props.content}
                            </div>
                            {this.props.isSaveButton || this.props.isCloseButton ?
                                <div className="Modal-footer modal-footer">
                                    {this.props.isSaveButton ?
                                        <Button className="Modal-button Modal-buttonSave"
                                                view="sky"
                                                size="s"
                                                onClick={this._onSaveClick}
                                                id={this.props.buttonSaveId}>
                                            {this.props.saveText}
                                        </Button>
                                        : ''}
                                    {this.props.isCloseButton ?
                                        <Button
                                            className="Modal-button Modal-buttonCancel"
                                            href="javascript:;"
                                            view="blackLink"
                                            size="s"
                                            //data-dismiss="modal"
                                            onClick={this._onCloseClick.bind(this, 'cancel')}>
                                            {this.props.closeText}
                                        </Button>
                                        : ''}
                                    <div className="clearfix"></div>
                                </div>
                            : ''}
                        </div>
                    </div>
                </div>
            </div>
        );
    }

}

export default Modal;



// WEBPACK FOOTER //
// ./client/components/Modal/Modal.js